<template>
  <v-app>
    <!-- ENCABEZADO -->
    <header class="buscadorCuenta">
      <button class="logo" @click="$router.push({ name: 'home' })">
        <img :src="require('@/assets/logo.png')" alt="Logo" />
      </button>
      <div class="buscador">
        <v-text-field
          v-model="query"
          prepend-inner-icon="mdi-magnify"
          label="¿Qué buscas?"
          variant="outlined"
          class="input-claro"
          hide-details
          density="comfortable"
          @keydown.enter="handleEnter"
        />
      </div>
      <template v-if="!isValid">
        <div class="cuenta">
          <v-btn icon class="bg-black">
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
          <v-btn class="bg-blue" @click="$router.push({ name: 'LoginView' })">
            Iniciar sesión
          </v-btn>
          <v-btn
            class="bg-blue"
            @click="$router.push({ name: 'RegistreView' })"
          >
            Crear cuenta
          </v-btn>
        </div>
        <div class="btn-menu-tongle">
          <v-menu>
            <template v-slot:activator="{ props }">
              <v-btn icon="mdi-dots-vertical" variant="text" v-bind="props">
                <label class="menu-icon" for="menu-toggle"> &#9776; </label>
              </v-btn>
            </template>

            <v-list class="bg-black">
              <v-list-item>
                <v-list-item-title class="v-list-item-title">
                  <v-btn
                    class="bg-black btn-menu"
                    @click="$router.push({ name: 'RegistreView' })"
                  >
                    <v-icon>mdi-account-details</v-icon>
                    Crear cuenta
                  </v-btn>
                </v-list-item-title>
                <v-list-item-title class="v-list-item-title">
                  <v-btn
                    class="bg-black btn-menu"
                    @click="$router.push({ name: 'LoginView' })"
                  >
                    <v-icon>mdi-account-circle</v-icon>
                    Iniciar sesión
                  </v-btn>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
      <template v-else>
        <ComponentMenuUser :user-info="userInfo" />
      </template>
    </header>
    <!-- MENÚ DE SECCIONES -->
    <nav class="menu-secciones">
      <div class="lista-secciones">
        <button
          v-for="seccion in secciones"
          :key="seccion.ruta"
          class="seccion"
          :class="{ activa: esActiva(seccion) }"
          @click="$router.push({ name: seccion.ruta })"
        >
          <v-icon size="19">{{ seccion.icono }}</v-icon>
          <span class="etiqueta">{{ seccion.nombre }}</span>
        </button>
      </div>
    </nav>
    <!-- CONTENIDO PRINCIPAL -->
    <v-main class="contenido">
      <router-view :key="$route.fullPath" />
    </v-main>
    <!-- FOOTER -->
    <!-- FOOTER -->
    <!-- FOOTER -->
    <footer class="footer-custom">
      <div class="footer-links">
        <!-- Siempre visibles. Salen del mismo array que el menu de secciones
             para que no puedan quedar desincronizados: antes eran cuatro span
             escritos a mano que repetian los mismos cuatro enlaces. -->
        <span
          v-for="seccion in secciones"
          :key="seccion.ruta"
          @click="$router.push({ name: seccion.ruta })"
        >{{ seccion.nombre }}</span>

        <!-- WhatsApp — siempre visible -->
        <a
          :href="`https://wa.me/57${whatsappNumber}`"
          target="_blank"
          rel="noopener"
          class="whatsapp-footer"
        >
          <v-icon size="15" style="vertical-align: middle;">mdi-whatsapp</v-icon>
          {{ whatsappNumber }}
        </a>

        <!-- No logeado -->
        <template v-if="!isValid">
          <span @click="$router.push({ name: 'LoginView' })">Iniciar sesión</span>
          <span @click="$router.push({ name: 'RegistreView' })">Crear cuenta</span>
        </template>

        <!-- Logeado -->
        <template v-else>
          <span @click="$router.push({ name: 'CountView' })">
            {{ userInfo.name }}
          </span>
          <span @click="$router.push({ name: 'myCompanysView' })"
            >Mis empresas</span
          >
          <span @click="$router.push({ name: 'MyPaymentsView' })"
            >Mis pagos</span
          >
          <!-- Solo admin -->
          <span v-if="esAdmin" @click="$router.push({ name: 'AdminSitesView' })">
            Administrar lugares
          </span>
          <!-- Enlace de soporte -->
          <a href="mailto:folustecno@gmail.com" class="support-link">
            Soporte
          </a>
        </template>
      </div>

      <div class="footer-copy">© Bahiol - Todos los derechos reservados</div>
    </footer>
  </v-app>
</template>

<script>
import apisUser from "@/apis/apisUsers";
import ComponentMenuUser from "./components/ComponentMenuUser.vue";
import Config from "@/Config";
export default {

  name: "App",
  components: {
    ComponentMenuUser,
  },
  data: function () {
    return {
      isValid: false,
      // Una sola lista en vez de cuatro propiedades y un switch de 25 lineas.
      // rutasActivas incluye las vistas de busqueda, para que la seccion siga
      // marcada cuando el usuario busca dentro de ella.
      secciones: [
        { nombre: 'Inicio',    ruta: 'home',             icono: 'mdi-home-outline',            rutasActivas: ['home', 'SearchView'] },
        { nombre: 'Empresas',  ruta: 'CompanysView',     icono: 'mdi-store-outline',           rutasActivas: ['CompanysView', 'SearchCompanysView'] },
        { nombre: 'Productos', ruta: 'ProductsView',     icono: 'mdi-package-variant-closed',  rutasActivas: ['ProductsView', 'SearchProductView'] },
        { nombre: 'Lugares',   ruta: 'SitesPublicView',  icono: 'mdi-map-marker-outline',      rutasActivas: ['SitesPublicView', 'AdminSitesView'] },
        { nombre: 'Rutas',     ruta: 'RutasView',        icono: 'mdi-map-marker-path',         rutasActivas: ['RutasView', 'ViewRutaView'] }
      ],
      query: "",
      userInfo: {
        idUser: null,
        user: "",
        password: "",
        name: "",
        surNames: "",
        email: "",
        age: null,
        role: "",
        phoneNumber: "",
      },
      sessionInterval: null,
      whatsappNumber: Config.whatsapp,
    };
  },
  computed: {
    esAdmin() {
      return this.userInfo.role === "administrador";
    },
  },
  beforeCreate() {
    apisUser
      .isValid()
      .then((idValid) => {
        this.isValid = idValid;

        if (this.isValid) {
          apisUser.GetMe().then((user) => {
            this.userInfo = user;
          });
        }
      })
      .catch(() => {
        this.isValid = false;
      });
  },
  mounted() {
    this.sessionInterval = setInterval(() => {
      this.checkSession();
    }, 3000);
  },
  beforeUnmount() {
    // 👈 limpiar intervalo para evitar fugas de memoria
    clearInterval(this.sessionInterval);
  },
  methods: {
    
    esActiva(seccion) {
      return seccion.rutasActivas.includes(this.$route.name);
    },
    handleEnter() {
      if (this.query) {
        // realizar direccionamiento segun la vista donde estemos
        let query = this.query;

        switch (this.$route.name) {
          case "ProductsView":
          case "SearchProductView":
            this.$router.push({ name: "SearchProductView", params: { query } });
            break;
          case "CompanysView":
          case "SearchCompanysView":
            this.$router.push({
              name: "SearchCompanysView",
              params: { query },
            });
            break;
          default:
            this.$router.push({ name: "SearchView", params: { query } });
            break;
        }
      }
    },
    checkSession() {
      apisUser
        .isValid()
        .then((isValid) => {
          this.isValid = isValid;

          if (this.isValid) {
            apisUser.GetMe().then((user) => {
              this.userInfo = user;
            });
          }
        })
        .catch(() => {
          this.isValid = false;
        });
    },
  },
};
</script>

<style scoped>
/* HEADER */
.buscadorCuenta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap; /* permite que el buscador baje en pantallas chicas */
  color: #1976d2;
  background-color: #0a0a0a;
  min-height: 70px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.logo {
  text-align: start;
}
.logo img {
  height: 45px;
}

.buscador {
  flex: 1;
  margin: 10px 20px;
  min-width: 200px;
}

.cuenta {
  display: flex;
  align-items: center;
  background-color: #1976d2;
  color: white;
  padding: 5px 10px;
  border-radius: 10px;
  gap: 10px;
  box-shadow: 0 2px 6px rgba(25, 118, 210, 0.4);
}

/* botones del header */
.cuenta .v-btn {
  font-weight: 500;
  border-radius: 6px;
  transition: background 0.3s ease;
}
.cuenta .v-btn:hover {
  filter: brightness(1.1);
}

.menu-usuario {
  min-width: 250px;
  width: 90vw; /* en móvil ocupa casi toda la pantalla */
}

#menu-toggle {
  display: none;
}

/* Icono hamburguesa */
.menu-icon {
  font-size: 28px;
  cursor: pointer;
  user-select: none;
  color: #fff;
  transition: transform 0.2s;
}
.menu-icon:hover {
  transform: scale(1.1);
}

/* Menú hamburguesa */
.menu {
  display: none;
  flex-direction: column;
  position: absolute;
  top: 70px; /* debajo del header */
  right: 10px;
  background: #1e1e1e;
  width: 220px;
  border-radius: 10px;
  padding: 10px;
  list-style: none;
  z-index: 1000;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
}

.menu li {
  color: white;
  padding: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
  transition: background 0.2s;
}

.menu li:hover {
  background: #2d2d2d;
}

/* Toggle visible */
#menu-toggle:checked + .menu-icon + .menu {
  display: flex;
}

/* Nav Desktop */
.btn-menu-tongle {
  display: none;
}
.btn-menu {
  width: 100%;
  justify-content: left;
}
/* Cuatro secciones caben en cualquier pantalla, asi que no hace falta el
   carrusel con flechas que habia antes.

   En celular la barra se fija ABAJO, al alcance del pulgar, como en una app.
   En pantalla grande se queda donde estaba, bajo el encabezado. */
.menu-secciones {
  background-color: #242424;
  display: flex;
  justify-content: center;
}

@media (max-width: 599px) {
  .menu-secciones {
    /* sticky y no fixed: la barra se queda pegada abajo mientras se navega,
       pero sigue ocupando su sitio en el flujo, asi que NUNCA tapa el
       contenido ni el pie. Por eso no hace falta reservarle hueco. */
    position: sticky;
    bottom: 0;
    /* v-app apila sus hijos en columna, asi que con order la barra se va al
       final sin mover nada en el HTML. Sin esto el sticky no serviria: su
       posicion natural esta arriba, justo debajo del encabezado. */
    order: 99;
    /* Por encima del contenido pero muy por debajo de los dialogos de
       Vuetify, que van en 2400: la barra no debe taparlos */
    z-index: 1005;
    border-top: 1px solid #3a3a3a;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.25);
    /* Franja inferior de los telefonos con gesto de inicio */
    padding-bottom: env(safe-area-inset-bottom, 0px);
  }
}
.lista-secciones {
  display: flex;
  width: 100%;
  max-width: 620px;
}
.seccion {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 9px 4px 7px;
  border: 0;
  border-bottom: 3px solid transparent;
  background: none;
  color: #9aa4b2;
  cursor: pointer;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  transition: color 0.15s ease, border-color 0.15s ease;
}
.seccion:hover {
  color: #e2e8f0;
}
/* La seccion actual se marca con subrayado y no rellenando el boton entero:
   se lee igual de claro y no compite con el resto de la pantalla */
.seccion.activa {
  color: #ffffff;
  border-bottom-color: #1976d2;
}

@media (min-width: 600px) {
  .seccion {
    flex-direction: row;
    gap: 7px;
    padding: 12px 8px 9px;
    font-size: 0.78rem;
  }
}

/* CONTENIDO */
.contenido {
  background-color: #fafafa;
  min-height: calc(100vh - 140px); /* Header + footer */
}

/* FOOTER */
footer {
  background-color: #0a0a0a;
  color: #fff;
  text-align: center;
  padding: 20px;
  font-size: 14px;
}
.footer-custom {
  background-color: #0a0a0a;
  color: #fff;
  text-align: center;
  padding: 15px;
  font-size: 14px;
}

.footer-links {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.footer-links span,
.footer-links a {
  cursor: pointer;
  transition: color 0.2s;
  text-decoration: none;
  color: #fff;
}

.footer-links span:hover,
.footer-links a:hover {
  color: #1976d2;
}

.footer-copy {
  font-size: 12px;
  opacity: 0.7;
}

.whatsapp-footer {
  color: #4caf50 !important;
  font-weight: 500;
}

.whatsapp-footer:hover {
  color: #81c784 !important;
}

/* HEADER con GRID */
.buscadorCuenta {
  display: grid;
  grid-template-columns: auto 1fr auto; /* logo - buscador - cuenta */
  align-items: center;
  color: #1976d2;
  background-color: #0a0a0a;
  padding: 10px 20px;
  min-height: 70px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  gap: 15px;
}

.logo img {
  height: 45px;
}

.buscador {
  width: 100%;
  margin-left: 5px;
}

.cuenta {
  display: flex;
  align-items: center;
  background-color: #1976d2;
  color: white;
  padding: 5px 10px;
  border-radius: 10px;
  gap: 10px;
  box-shadow: 0 2px 6px rgba(25, 118, 210, 0.4);
}

/* RESPONSIVE */
@media screen and (max-width: 600px) {
  .buscadorCuenta {
    grid-template-columns: auto auto; /* logo - menú/botones */
    grid-template-rows: auto auto; /* buscador abajo */
  }

  .buscador {
    grid-column: 1 / -1; /* que ocupe todo el ancho */
    order: 3;
    margin-top: 10px;
  }

  .cuenta,
  .btn-menu-user {
    display: none; /* ocultamos cuenta normal en móvil */
  }

  .btn-menu-tongle {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
